import { CaretIcon } from '@ui/icons/Caret.icon'

import { useWindowResize } from '@utils/domUtils'

import { TableCell } from '../Table'
import { BaseColumn, BaseColumnCtx } from '../types'
import { VIEW_MORE_ARROW_COL_KEY } from './useTableSearch'

interface UseTableRowsOptions<
  TDto,
  TFormatCtx extends BaseColumnCtx,
  TColumn extends BaseColumn<TDto, TFormatCtx, string | null | undefined>
> {
  columns: TColumn[]
  formatCtx: TFormatCtx
  onArrowClick: (item: TDto, index: number) => void
}

export const useTableColumns = <
  TDto,
  TFormatCtx extends BaseColumnCtx,
  TColumn extends BaseColumn<TDto, TFormatCtx, string | null | undefined>
>({
  columns,
  formatCtx,
  onArrowClick,
}: UseTableRowsOptions<TDto, TFormatCtx, TColumn>) => {
  const isMobile = useWindowResize()
  const renderColumns = (item: TDto, index: number): React.ReactNode[] => {
    const visibleColumns = isMobile
      ? columns.filter(({ visibleOnMobile }) => visibleOnMobile)
      : columns.filter(
          ({ id, visibleOnDesktop = true }) => id !== VIEW_MORE_ARROW_COL_KEY && visibleOnDesktop
        )

    return visibleColumns.map((col) => (
      <TableCell
        key={col.id ?? index}
        align={col.align}
        sensitive={col.sensitive}
        {...(isMobile &&
          col.id === VIEW_MORE_ARROW_COL_KEY && {
            onClick: () => onArrowClick(item, index),
            hasTruncate: false,
            width: col.width,
          })}
      >
        {col.id === VIEW_MORE_ARROW_COL_KEY ? (
          <CaretIcon.Right color='text-low-em' size={20} />
        ) : (
          col.getValue(item, formatCtx)
        )}
      </TableCell>
    ))
  }

  return { renderColumns }
}
